<isophi-app-portfolio-plan-base-item #base *transloco="let t" [leftIcon]="'cognition'" [title]="t('planDetail/selfReflection')" [allowEditMode]="allowEditMode">
  <div class="question-list">
    <div class="question" [class.edit-mode]="base.isEditMode()">
      <div class="question-text">{{ t('planDetail/activityHelped') }}</div>
      <div class="question-response">
        <isophi-app-emoji-rating-display *ngIf="base.isViewMode()" [value]="form.controls.activityHelped.value"></isophi-app-emoji-rating-display>
        <isophi-app-emoji-rating
          *ngIf="allowEditMode && base.isEditMode()"
          [control]="form.controls.activityHelped"
          (valueChange)="form.controls.activityHelped.setValue($event)"
        ></isophi-app-emoji-rating>
      </div>
    </div>
    <!-- <div class="question" [class.edit-mode]="base.isEditMode()">
      <div class="question-text">{{ t('planDetail/knowledgeUsage') }}</div>
      <div class="question-response">
        <isophi-app-emoji-rating-display *ngIf="base.isViewMode()" [value]="form.controls.knowledgeUsage.value"></isophi-app-emoji-rating-display>
        <isophi-app-emoji-rating
          *ngIf="allowEditMode && base.isEditMode()"
          [control]="form.controls.knowledgeUsage"
          (valueChange)="form.controls.knowledgeUsage.setValue($event)"
        ></isophi-app-emoji-rating>
      </div>
    </div>
    <div class="question" [class.edit-mode]="base.isEditMode()">
      <div class="question-text">{{ t('planDetail/challengeExperienced') }}</div>
      <div class="question-response">
        <isophi-app-emoji-rating-display *ngIf="base.isViewMode()" [value]="form.controls.challengeExperienced.value"></isophi-app-emoji-rating-display>
        <isophi-app-emoji-rating
          *ngIf="allowEditMode && base.isEditMode()"
          [control]="form.controls.challengeExperienced"
          (valueChange)="form.controls.challengeExperienced.setValue($event)"
        ></isophi-app-emoji-rating>
      </div>
    </div> -->
    <div class="question" [class.edit-mode]="base.isEditMode()">
      <div class="question-text">{{ t('planDetail/expectationsMet') }}</div>
      <div class="question-response">
        <isophi-app-emoji-rating-display *ngIf="base.isViewMode()" [value]="form.controls.expectationsMet.value"></isophi-app-emoji-rating-display>
        <isophi-app-emoji-rating
          *ngIf="allowEditMode && base.isEditMode()"
          [control]="form.controls.expectationsMet"
          (valueChange)="form.controls.expectationsMet.setValue($event)"
        ></isophi-app-emoji-rating>
      </div>
    </div>
    <!-- <div class="question" [class.edit-mode]="base.isEditMode()">
      <div class="question-text">{{ t('planDetail/feelsMoreConfident') }}</div>
      <div class="question-response">
        <isophi-app-emoji-rating-display *ngIf="base.isViewMode()" [value]="form.controls.feelsMoreConfident.value"></isophi-app-emoji-rating-display>
        <isophi-app-emoji-rating
          *ngIf="allowEditMode && base.isEditMode()"
          [control]="form.controls.feelsMoreConfident"
          (valueChange)="form.controls.feelsMoreConfident.setValue($event)"
        ></isophi-app-emoji-rating>
      </div>
    </div> -->
    <div class="question" [class.edit-mode]="base.isEditMode()">
      <div class="question-text w-100">
        <div class="mb-3 w-100">{{ t('planDetail/selfReflectionText') }}</div>
        <div *ngIf="base.isViewMode()">{{ form.controls.selfReflectionText.value }}</div>
        <textarea *ngIf="allowEditMode && base.isEditMode()" class="custom-textarea w-100" rows="3" [formControl]="form.controls.selfReflectionText">
        </textarea>
      </div>
    </div>
    <div *ngIf="allowEditMode && base.isEditMode()" class="actions d-flex justify-content-end">
      <button (click)="cancel(); base.setMode(base.modeEnum.VIEW)" class="btn btn-light-outline">
        {{ t('common/cancel') }}
      </button>

      <button (click)="save(); base.setMode(base.modeEnum.VIEW)" class="btn btn-primary">
        {{ t('common/save') }}
      </button>
    </div>
  </div>
</isophi-app-portfolio-plan-base-item>
